import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'

import { TableRow } from './components/TableRow/TableRow'

import { MAX_BUILDING_LEVEL } from 'constants'

import styles from './BaseBonusInfoTable.scss'

export class BaseBonusInfoTable extends React.Component {
    constructor(props) {
        super(props)
        this.tableHeaderRefs = {}
        this.tableColumnsRefs = {}
        this.state = {
            columnsWidthConfig: {},
        }
    }

    setTableColumnsRefs = (el, dataIndex) => {
        if (!this.tableColumnsRefs[dataIndex]) {
            this.tableColumnsRefs[dataIndex] = []
        }

        this.tableColumnsRefs[dataIndex].push(el)
    }

    setColumnWidthConfig = () => {
        const columnsWidthConfig = this.props.columns.map(column => column.dataIndex)
            .reduce((acc, columnKey) => {
                const columnHeaderWidth = this.tableHeaderRefs[columnKey].clientWidth
                const columnCells = this.tableColumnsRefs[columnKey]
                const columnCellsWidth = columnCells.map((columnCellEl) => columnCellEl.clientWidth)

                acc[columnKey] = Math.max(columnHeaderWidth, ...columnCellsWidth)
                return acc
            }, {})

        this.setState({ columnsWidthConfig })
    }

    componentDidMount = () => {
        this.setColumnWidthConfig()
    }

    render() {
        const {
            className,
            classNames = {},
            title,
            notice,
            footer,
            columns,
            selectedRow,
            dataSource,
        } = this.props

        const { columnsWidthConfig } = this.state

        return (
            <div className={className}>
                <p className={cx(styles.title, classNames.title)}>
                    {title}
                </p>
                {notice && <p className={styles.notice}>{notice}</p>}
                <div className={styles.table}>
                    <div className={styles.thead}>
                        <div className={styles.tr}>
                            {columns.map(({
                                title,
                                classNames: columnClassNames = {},
                                dataIndex,
                                align,
                                isCalculatedWidth,
                            }) => {
                                return (
                                    <div
                                        key={dataIndex}
                                        className={cx(
                                            styles.th,
                                            styles.th__right || (align && styles[`th__${align}`]),
                                            isCalculatedWidth && styles.th__calculatedWidth,
                                            columnClassNames.th,
                                        )}
                                        ref={el => this.tableHeaderRefs[dataIndex] = el}
                                        style={{ '--cell-width': `${columnsWidthConfig[dataIndex]}px` }}
                                    >
                                        {title}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div className={styles.tbody}>
                        {dataSource.map((bonus, rowIndex) => {
                            if (rowIndex < MAX_BUILDING_LEVEL) {
                                return (
                                    <TableRow
                                        key={rowIndex}
                                        rowIndex={rowIndex}
                                        selectedRow={selectedRow}
                                        columns={columns}
                                        bonus={bonus}
                                        setTableColumnsRefs={this.setTableColumnsRefs}
                                        columnsWidthConfig={columnsWidthConfig}
                                    />
                                )
                            }
                        })}
                    </div>
                    {footer && <div className={styles.tfoot}>{footer}</div>}
                </div>
            </div>
        )
    }
}

BaseBonusInfoTable.propTypes = {
    title: PropTypes.node.isRequired,
    notice: PropTypes.node,
    footer: PropTypes.node,
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.node.isRequired,
            dataIndex: PropTypes.string.isRequired,
            render: PropTypes.func,
        })
    ).isRequired,
    dataSource: PropTypes.array.isRequired,
    selectedRow: PropTypes.number,
    className: PropTypes.string,
    classNames: PropTypes.shape({
        title: PropTypes.string,
    }),
}

export default BaseBonusInfoTable



// WEBPACK FOOTER //
// ./components/BaseBonusInfoTable/BaseBonusInfoTable.jsx